import './FavoritesHeader.css';const favoritesHeader = "_favoritesHeader_nczty_1";
const styles = {
  favoritesHeader
};
export {
  styles as default,
  favoritesHeader
};
